import React, { Component } from "react";
import propertiesStyle from "./Properties.module.css";
import textStyles from "./Text.module.css";
import TriangleDown from "../../SVG/TriangleDown";
import TriangleRight from "../../SVG/TriangleRight";
import { setProperty as SET_PROPERTY } from "../../Scripts/PropertyUtils";
import { SketchPicker } from "react-color";
import DragInput from "../DragInput/DragInput";

export default class Stroke extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colorClicked: false,
      open: false,
    };
  }

  ensureStroke() {
    if (!this.props.item.stroke) {
      this.props.item.stroke = {
        enabled: false,
        colour: "#ffffff",
        width: 2,
        alignment: 0.5,
      };
    } else if (this.props.item.stroke.alignment === undefined) {
      this.props.item.stroke.alignment = 0.5;
    }
  }

  colorClicked() {
    this.setState({ colorClicked: !this.state.colorClicked });
  }

  handleColorChange(color) {
    this.ensureStroke();
    SET_PROPERTY(this.props.item, "stroke.colour", color.hex);
    this.forceUpdate();
  }

  updateProperty(property, value) {
    this.ensureStroke();
    SET_PROPERTY(this.props.item, property, value);
    this.setState({ update: true });
  }

  render() {
    this.ensureStroke();
    const stroke = this.props.item.stroke;
    const color = stroke.colour || "#ffffff";

    return (
      <div className={propertiesStyle.Group}>
        <div
          className={propertiesStyle.GroupTitle}
          onClick={() => this.setState({ open: !this.state.open })}
        >
          <div className={propertiesStyle.Open}>
            {this.state.open && <TriangleDown />}
            {!this.state.open && <TriangleRight />}
          </div>
          <div className={propertiesStyle.Title}>Stroke</div>
        </div>
        {this.state.open && (
          <div className={textStyles.Group}>
            <div className={textStyles.lists}>
              <div className={textStyles.Property}>
                <label className={textStyles.CheckboxContainer}>
                  Enabled
                  <input
                    type="checkbox"
                    checked={stroke.enabled ? true : false}
                    onChange={(e) => {
                      this.updateProperty(
                        "stroke.enabled",
                        e.currentTarget.checked
                      );
                    }}
                  />
                  <span className={textStyles.Checkmark} />
                </label>
              </div>
              {(this.props.item.type === "RECTANGLE" ||
                this.props.item.type === "CIRCLE") && (
                <div className={textStyles.Property}>
                  <label className={textStyles.CheckboxContainer}>
                    Fill
                    <input
                      type="checkbox"
                      checked={this.props.item.fillEnabled !== false}
                      onChange={(e) => {
                        this.updateProperty(
                          "fillEnabled",
                          e.currentTarget.checked
                        );
                      }}
                    />
                    <span className={textStyles.Checkmark} />
                  </label>
                </div>
              )}
            </div>
            <div className={textStyles.lists}>
              <div className={textStyles.Property}>
                <div
                  style={{ backgroundColor: color }}
                  className={textStyles.Color}
                  onClick={() => this.colorClicked()}
                />
                <div className="ColourPicker">
                  <div
                    className="Dropdown"
                    style={
                      this.state.colorClicked
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <SketchPicker
                      disableAlpha={true}
                      color={color}
                      onChange={(c) => this.handleColorChange(c)}
                      styles={{
                        picker: {
                          backgroundColor: "#373a4a",
                          padding: "10px 10px 0px",
                          borderRadius: "4px",
                          boxShadow:
                            "rgba(0, 0, 0, 0.15) 0px 0px 0px 1px, rgba(0, 0, 0, 0.15) 0px 8px",
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className={textStyles.Property}>
                <label>Size</label>
                <DragInput
                  type="number"
                  min="1"
                  value={stroke.width || 2}
                  onChange={(value) => {
                    this.updateProperty("stroke.width", parseInt(value));
                  }}
                />
              </div>
              <div className={textStyles.Property}>
                <label>Position</label>
                <div style={{ display: "flex", gap: "4px", marginTop: "4px" }}>
                  {[
                    { label: "Inside", value: 0 },
                    { label: "Middle", value: 0.5 },
                    { label: "Outside", value: 1 },
                  ].map(({ label, value }) => (
                    <div
                      key={value}
                      onClick={() =>
                        this.updateProperty("stroke.alignment", value)
                      }
                      style={{
                        flex: 1,
                        textAlign: "center",
                        padding: "4px 0",
                        borderRadius: "4px",
                        fontSize: "0.75em",
                        cursor: "pointer",
                        backgroundColor:
                          stroke.alignment === value ? "#db0a41" : "#12161d",
                        color: "#fff",
                        userSelect: "none",
                      }}
                    >
                      {label}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
